<template>
  <div class="auth-container">
    <div class="auth-card">
      <div class="auth-header">
        <v-icon color="#4F46E5" size="48" class="auth-icon">
          mdi-shield-check
        </v-icon>
        <h2 class="auth-title">دسترسی به پنل مدیریت</h2>
        <p class="auth-subtitle">برای ورود به پنل مدیریت پیام‌های پاپ‌آپ، توکن امنیتی را وارد کنید</p>
      </div>
      
      <div class="auth-form">
        <div class="form-group">
          <label class="form-label">توکن امنیتی</label>
          <input
            v-model="token"
            type="password"
            placeholder="توکن امنیتی را وارد کنید"
            class="form-input"
            @keyup.enter="verifyToken"
            @input="clearError"
          >
        </div>
        
        <div v-if="error" class="error-message">
          <v-icon color="#EF4444" size="16">mdi-alert-circle</v-icon>
          <span>{{ error }}</span>
        </div>
        
        <button
          class="auth-button"
          :disabled="!token || loading"
          @click="verifyToken"
        >
          <v-icon v-if="loading" class="spin">mdi-loading</v-icon>
          <v-icon v-else left size="20">mdi-login</v-icon>
          {{ loading ? 'در حال بررسی...' : 'ورود به پنل' }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PopupMessageAuth',
  data() {
    return {
      token: '',
      error: '',
      loading: false,
      ADMIN_TOKEN: '876523' // توکن ثابت
    }
  },
  
  mounted() {
    // بررسی اینکه آیا توکن قبلاً ذخیره شده یا نه
    const savedToken = localStorage.getItem('popup_admin_token')
    if (savedToken === this.ADMIN_TOKEN) {
      this.$router.push('/admin/popup-message/list')
    }
  },
  
  methods: {
    verifyToken() {
      if (!this.token.trim()) {
        this.error = 'لطفاً توکن امنیتی را وارد کنید'
        return
      }
      
      this.loading = true
      this.error = ''
      
      // شبیه‌سازی بررسی توکن با تأخیر
      setTimeout(() => {
        if (this.token === this.ADMIN_TOKEN) {
          // ذخیره توکن در localStorage
          localStorage.setItem('popup_admin_token', this.token)
          
          // هدایت به پنل مدیریت
          this.$router.push('/admin/popup-message/list')
        } else {
          this.error = 'توکن امنیتی اشتباه است'
          this.token = ''
        }
        this.loading = false
      }, 1000)
    },
    
    clearError() {
      this.error = ''
    }
  }
}
</script>

<style scoped>
.auth-container {
  min-height: 100vh;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  direction: rtl;
}

.auth-card {
  background: white;
  border-radius: 20px;
  padding: 40px;
  width: 100%;
  max-width: 420px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.1);
  text-align: center;
}

.auth-header {
  margin-bottom: 30px;
}

.auth-icon {
  background: rgba(79, 70, 229, 0.1);
  padding: 15px;
  border-radius: 50%;
  margin-bottom: 20px;
}

.auth-title {
  color: #1f2937;
  font-size: 24px;
  font-weight: 700;
  margin: 0 0 8px 0;
}

.auth-subtitle {
  color: #6b7280;
  font-size: 14px;
  line-height: 1.5;
  margin: 0;
}

.auth-form {
  text-align: right;
}

.form-group {
  margin-bottom: 20px;
}

.form-label {
  display: block;
  margin-bottom: 8px;
  font-size: 14px;
  font-weight: 500;
  color: #374151;
}

.form-input {
  width: 100%;
  padding: 12px 16px;
  border: 2px solid #e5e7eb;
  border-radius: 12px;
  font-size: 16px;
  direction: ltr;
  text-align: center;
  font-family: 'Courier New', monospace;
  transition: all 0.3s ease;
  background: #f9fafb;
}

.form-input:focus {
  outline: none;
  border-color: #4f46e5;
  background: white;
  box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.1);
}

.error-message {
  display: flex;
  align-items: center;
  gap: 8px;
  background: rgba(239, 68, 68, 0.1);
  color: #ef4444;
  padding: 12px 16px;
  border-radius: 8px;
  font-size: 14px;
  margin-bottom: 20px;
}

.auth-button {
  width: 100%;
  padding: 14px 20px;
  background: linear-gradient(45deg, #4f46e5, #7c3aed);
  color: white;
  border: none;
  border-radius: 12px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.auth-button:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(79, 70, 229, 0.3);
}

.auth-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
}

.spin {
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

@media (max-width: 480px) {
  .auth-card {
    padding: 30px 20px;
  }
  
  .auth-title {
    font-size: 20px;
  }
  
  .auth-subtitle {
    font-size: 13px;
  }
}
</style>